var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMembershipDiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18L0 6L3 0H17L20 6L10 18ZM7.625 5H12.375L10.875 2H9.125L7.625 5ZM9 13.675V7H3.45L9 13.675ZM11 13.675L16.55 7H11V13.675ZM14.6 5H17.25L15.75 2H13.1L14.6 5ZM2.75 5H5.4L6.9 2H4.25L2.75 5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembershipDiamond);
export default __webpack_public_path__ + "static/media/membership_diamond.db683132cc80ca45d0595736a134ff3d.svg";
export { ForwardRef as ReactComponent };